import { css, jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import React from 'react';

import contentStyle from '@/src/cms/contentStyle';
import Container from '@/src/shared/components/Container';
import Heading from '@/src/shared/components/Heading';
import Section from '@/src/shared/components/Section';
import { space } from '@/styles';

import Accordions from './Accordions';
import FullWidthParagraph from './FullWidthParagraph';
import FullWidthParagraphVideo from './FullWidthParagraphVideo';
import HalfParagraphHalfVideo from './HalfParagraphHalfVideo';
import HalfWidthParagraphCard from './HalfWidthParagraphCard';
import HeroSlides from './HeroSlides';
import Infographics from './Infographics';
import Topics from './Topics';

const BLOCK_MAP = {
  ID_1: FullWidthParagraph,
  ID_2: FullWidthParagraphVideo,
  ID_3: HalfWidthParagraphCard,
  ID_4: Infographics,
  ID_5: Accordions,
  ID_6: Topics,
  ID_9: HalfParagraphHalfVideo,
  ID_10: HeroSlides,
};

const { m } = space;
const style = {
  section: css`
    padding-top: 32px !important;
    padding-bottom: 32px !important;
  `,
};

const Block = ({ blockData, entities }) => {
  const SelectedBlock = BLOCK_MAP[`ID_${blockData.BlockTypeId}`];

  if (SelectedBlock) {
    return (
      <Section bgColor={blockData.BackgroundColor} css={style.section}>
        <Container>
          {blockData.BlockTitle && (
            <Heading
              type={2}
              weight="bold"
              theme={blockData.BackgroundColor === 'blue' ? 'white' : 'primaryGray'}
              css={[m.b32]}
            >
              {blockData.BlockTitle}
            </Heading>
          )}
          <SelectedBlock blockData={blockData} entities={entities} css={contentStyle} />
        </Container>
      </Section>
    );
  }
  console.warn('There is no matching block.');
  return undefined;
};

Block.propTypes = {
  blockData: PropTypes.object.isRequired,
  entities: PropTypes.object.isRequired,
};

export default Block;
